import { Box, Button, Container, Divider, Grid, IconButton, Paper } from "@mui/material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import globalContext from '../context/context'
import axios from "axios";
import { useTranslation } from "react-i18next";
import { isInCart } from "../utils/cart";

function TransferPopup() {

    const { t } = useTranslation();

    const { contextData: { responseId, transfer, currency, cart }, addToCart, setTransfer } = useContext(globalContext);
    const navigate = useNavigate();

    const [details, setDetails] = useState(false);

    useEffect(() => {
        if (!parseInt(responseId, 10)) {
            navigate('/');
        }
    }, [])

    useEffect(() => {

        const getTransfers = setTimeout(() => {
            if (!!parseInt(responseId, 10)) {
                axios.get(`/api/custom/transfers?searchId=${parseInt(responseId, 10)}&currency=${currency}`).then(r => {
                    setTransfer(r?.data);
                }).catch(e => {
                    setTransfer(null);
                })
            }
        }, 400);


        return () => {
            clearTimeout(getTransfers);
        }

    }, [responseId])


    return (
        <>
            <Box className="orderElement" sx={{ bgcolor: 'rgba(0,0,0, .2)' }}>
                <Container sx={{ justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex' }} >
                    <Paper className="orderElementPaper" sx={{ width: { xs: '95%', md: '60%' }, p: 3, bgcolor: '#fff' }}>
                        <Grid sx={{ justifyContent: 'space-between', alignItems: 'center' }} container>
                            <Grid item>
                                <Box sx={{ display: 'inline-block', color: '#d93e45', fontSize: '16px', fontWeight: 500 }}>
                                    <Box sx={{
                                        width: '40px',
                                        height: '40px',
                                        display: 'inline-block',
                                        mr: 2,
                                        verticalAlign: 'middle',
                                        backgroundImage: `url('/images/airport_transfer.png')`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                    }}></Box>
                                    {t('PopupPages.transfer')}
                                </Box>
                            </Grid>
                            <Grid item>
                            </Grid>
                        </Grid>
                        {transfer && <>
                            {transfer?.length > 0 ?
                                <>
                                    <Grid sx={{ py: 2 }} >
                                        <Divider />
                                    </Grid>
                                </>
                                :
                                <>
                                    <Grid sx={{ py: 2 }} >
                                        <Divider />
                                    </Grid>
                                    <Grid sx={{ py: 2 }} >
                                        Coming soon…
                                    </Grid>
                                </>
                            }
                        </>}

                        {transfer?.map((tr, tKey) => <React.Fragment key={tKey}>
                            <Grid>
                                <Box sx={{ fontSize: '14px', fontWeight: 500, pb: 1 }}>
                                    {tr.name} ({tr?.airportCode})
                                </Box>
                                <Box>
                                    <Grid sx={{ textAlign: 'center', py: 2 }} spacing={2} container>
                                        <Grid item>
                                            <Box sx={{ fontWeight: 300, fontSize: '10px', p: 1 }}>
                                                {tr?.productType == 'TRANSFER_PRIVATE' ? 'per car' : 'per person'}
                                            </Box>
                                            <Box className="popupButton" sx={{ fontWeight: 700, fontSize: '16px', borderRadius: '20px', border: '1px solid #333', p: 1 }}>
                                                {tr?.priceInCurrency} {tr?.currency}
                                            </Box>
                                            <Box sx={{ fontWeight: 300, fontSize: '10px', px: 1, pb: 1 }}>
                                                {t('PopupPages.numberOfCars')} {tr.quantity}
                                            </Box>

                                        </Grid>
                                        <Grid item>

                                             <Button
                                                 className="popupButton"
                                                 onClick={() => addToCart(tr, 'transfers')}
                                                 sx={{ fontWeight: 700, cursor: 'pointer', lineHeight: 1.25, color: '#d93e45', fontSize: '16px', borderRadius: '20px', border: isInCart(cart, tr).isInCart ? '1px solid green' : '1px solid #d93e45', py: 1, px: 3, mt: 3.5 }}>
                                                 {isInCart(cart, tr).isInCart ? t("PopupPages.remove") : t("PopupPages.cart")}
                                             </Button>

                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ fontSize: '12px', fontWeight: 300 }}>
                                    {details
                                        ? tr.description
                                        : <><strong style={{ cursor: 'pointer' }} onClick={() => setDetails(true)}>{t("PopupPages.clickHere")}</strong> {t("PopupPages.serviceDetails")}</>}
                                </Box>

                            </Grid>
                        </React.Fragment>)}
                    </Paper>
                </Container>

            </Box>

        </>
    );
}

export default TransferPopup;
